<template>
    <tr v-if="collapseActive && outputItems && outputItems.length" class="lms__superadmin_users_list_table_item_collapse_table">
        <td class="lms__superadmin_users_list_table_item_collapse_table_wrapper" colspan="4">
            <table>
                <list-table-head :labels="tableLabels"/>
                <tbody>
                <template
                    v-for="(item, index) in outputItems"
                >
                    <lms-superadmin-users-list-table-item-collapse-table-item
                        :item="item"
                        :invitations="invitations"
                        :key="`lms-superadmin-users-list-table-item-collapse-table-${index}`"
                        @emit="handlePerformEmit"
                    />
                </template>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import LmsSuperadminUsersListTableItemCollapseTableItem from '@/components/lms/superadmin/users/list/LmsSuperadminUsersListTableItemCollapseTableItem'
import { User } from '@/User'

export default {
  name: 'lms-superadmin-users-list-table-item-collapse-table',
  components: { LmsSuperadminUsersListTableItemCollapseTableItem, ListTableHead },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tableLabels () {
      let labelsArr = []

      labelsArr.push('Customer')

      if (this.firstProfileWorkspaceId) {
        labelsArr.push('Workspace')
        labelsArr.push('Roles')
      }

      labelsArr.push('Status')

      if (this.firstProfileWorkspaceId || (this.firstProfileWorkspaceId && this.firstProfileStatus === 'invited')) {
        labelsArr.push('Actions')
      }

      return labelsArr
    },
    firstProfile () {
      return this.profiles[0]
    },
    firstProfileWorkspaceId () {
      return this.firstProfile ? this.firstProfile.workspaceId : null
    },
    firstProfileStatus () {
      return this.firstProfile ? this.firstProfile.status : null
    },
    profiles () {
      return this.item.profiles
    },
    profile () {
      return [{
        id: this.item.profileId,
        status: this.item.profileStatus,
        roles: this.item.profileRoles
      }]
    },
    profileId () {
      return this.item.profileId || undefined
    },
    invitations () {
      return this.item.invitations
    },
    outputItems () {
      const profiles = this.profiles
      let profilesOutput = []

      if (profiles && profiles.find(obj => obj.workspaceId)) {
        profilesOutput = profiles.filter(obj => obj.workspaceId)
      } else {
        profilesOutput = profiles
      }

      return profilesOutput
    }
  },
  methods: {
    handlePerformEmit (data) {
      const message = data.message
      const value = data.value
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminuserslisttableitemcollapse.scss";
</style>
